import { firstNamesBase } from '../lib';
import { getRandomElementFromArray } from '../../../../../utils';

export function generateRandomFirstName(): string {
    return getRandomElementFromArray(firstNamesBase);
}
